import {
    Group,
    Stack,
    Text,
} from '@mantine/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardEntryInput,
} from '@flexinet/ui-components';

import {TestDefinition} from '../types';
import {useApplicationName} from '../../testing-api-integration/hooks/useApplicationOptions';
import {TestDefinitionStatusBadge} from './TestDefinitionStatusBadge.tsx';
import {StepsList} from './StepsList.tsx';
import {SetStatusButtons} from '../buttons/SetStatusButtons.tsx';

export const Profile = ({record}: { record: TestDefinition }) => {

    // The application NAME, falling back to the raw id when it cannot be
    // resolved (archived, or not visible to this operator) — a dangling
    // reference stays visible rather than rendering blank.
    const applicationName = useApplicationName(record.applicationId);

    const properties: PlatformPropertyCardEntryInput[] = [
        {
            label: 'Test Code',
            value: record.testCode,
            formatter: 'code',
            span: 12,
        }, {
            label: 'Name',
            value: record.name,
            span: 12,
        }, {
            label: 'Description',
            value: record.description ?? 'n/a',
            span: 12,
        }, {
            label: 'Target Application',
            value: applicationName ?? 'n/a',
            span: 12,
        }];

    const properties2: PlatformPropertyCardEntryInput[] = [
        {
            label: 'Created By',
            value: record.createdByUsername ?? 'n/a',
            span: 12,
        }, {
            label: 'Created',
            value: record.created,
            formatter: 'timestamp',
            span: 12,
        }, {
            label: 'Last Updated',
            value: record.updated,
            formatter: 'timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <Stack gap={'xs'}>
                <Group justify={'space-between'}>
                    <Text size={'sm'} c={'dimmed'}>Status</Text>
                    <TestDefinitionStatusBadge status={record.status}/>
                </Group>
                <SetStatusButtons record={record}/>
            </Stack>

            <PlatformPropertyCard properties={properties}/>

            <Stack gap={'xs'}>
                <Text size={'sm'} c={'dimmed'}>Steps</Text>
                <StepsList steps={record.steps}/>
            </Stack>

            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );
};
